import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { voucherSchema } from '../types';

export const createBlockVoucherMutation = () =>
	createAuthMutation({
		params: declareParams<number>(),
		request: {
			method: 'POST',
			url: (id) => `/voucher/lock/${id}`,
			body: () => ({}),
		},
		response: {
			contract: zodContract(voucherSchema),
		},
	});
